export default {
  isochrones: {
    'isochrones': 'Isocrone',
    'isochronesReady': 'Isocrone pronte',
    'calculatingIsochrones': 'Calcolando isocrone ...',
    'itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions': 'Non è stato possibile calcolare le isocrone con queste opzioni. Tenta di definire isocrone più piccole.',
    'couldResolveTheSelectedPlaceAsASuitableCenter': 'Il luogo scelto non può essere usato come centro.',
    'apiError': {
      '2003': 'L\'area del poligono da evitare non deve superare i 20.000 chilometri quadrati.',
      '3001': 'Almeno un parametro ha un valore falso o un falso formato.',
      '3004': 'La combinazione di mezzo di trasporto, d\'intervallo e di tempo o distanza eccede il valore massimo dell\'istanza ORS. Cambia i valori.',
      '3099': 'Impossibile creare una mappa isocrona con i punti e il mezzo di trasporto selezionati.'
    },
    'genericErrorMsg': 'Non è stato possibile calcorare gli isocroni.',
    timeoutError: 'La richiesta ha richiesto troppo tempo ed è stata annullata. Prova intervalli o range più piccoli.'
  }
}
